/**
 * @generated SignedSource<<e29b44eefada81ba566acbb29d07a154>>
 * @relayHash b82ef477c94cdc6484b965d3c8f1fadc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 47f415f98abb138ce974c53f4d12877d0dedfc6fe4b907da24452dcb350a0374

import type { ConcreteRequest } from 'relay-runtime';
export type WelcomeMessagesQuery$variables = Record<PropertyKey, never>;
export type WelcomeMessagesQuery$data = {
  readonly spaViewContext: {
    readonly resourceContexts: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly resourceKeys: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly showEditButton: boolean | null | undefined;
    readonly showWelcomeMessageEditHint: boolean | null | undefined;
    readonly welcomeMessageEditUrl: string | null | undefined;
    readonly welcomeMessageHtml: string | null | undefined;
  } | null | undefined;
};
export type WelcomeMessagesQuery = {
  response: WelcomeMessagesQuery$data;
  variables: WelcomeMessagesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "SpaViewModel",
    "kind": "LinkedField",
    "name": "spaViewContext",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "welcomeMessageEditUrl"
      },
      {
        "kind": "ScalarField",
        "name": "welcomeMessageHtml"
      },
      {
        "kind": "ScalarField",
        "name": "resourceKeys"
      },
      {
        "kind": "ScalarField",
        "name": "resourceContexts"
      },
      {
        "kind": "ScalarField",
        "name": "showWelcomeMessageEditHint"
      },
      {
        "kind": "ScalarField",
        "name": "showEditButton"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "WelcomeMessagesQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WelcomeMessagesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b82ef477c94cdc6484b965d3c8f1fadc",
    "id": "47f415f98abb138ce974c53f4d12877d0dedfc6fe4b907da24452dcb350a0374",
    "metadata": {},
    "name": "WelcomeMessagesQuery",
    "operationKind": "query",
    "text": "query WelcomeMessagesQuery{spaViewContext{welcomeMessageEditUrl,welcomeMessageHtml,resourceKeys,resourceContexts,showWelcomeMessageEditHint,showEditButton}}"
  }
};
})();

(node as any).hash = "e98cc529a578d7939fe5dffe3a5aaea0";

export default node;
